import React from 'react';

function NotificationsFooter() {
  return (
    <div className="flex items-center justify-between gap-[20px] my-[10px] text-[15px]">
      <div className="w-[185px] text-addition11 font-medium">
        <div>0.5 GB (1%) of 15 GB used</div>
        <div className="underline cursor-pointer">Manage</div>
      </div>
      <div className="flex items-center text-addition11-40 gap-[3px]">
        <div>© 2014 Google -</div>
        <div className="underline cursor-pointer">Terms & Privacy</div>
      </div>
    </div>
  );
}

export default NotificationsFooter;
